import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const questionById: ApiFunc<`${typeof API.QUESTION}{id}`, 'get'> = data =>
  instance.get(`${API.QUESTION}${'id' in data ? data.id : data.name}`)

export const questionCreate: ApiFunc<`${typeof API.QUESTION}`, 'post'> = data => instance.post(API.QUESTION, data)

export const questionDelete: ApiFunc<`${typeof API.QUESTION}{id}`, 'delete'> = data =>
  instance.delete(`${API.QUESTION}${'id' in data ? data.id : data.name}`)

export const questionAll: ApiFunc<`${typeof API.QUESTION_ALL}`, 'get'> = data =>
  instance.get(API.QUESTION_ALL, { params: data })

export const questionTypes: ApiFunc<`${typeof API.QUESTION_TYPES}`, 'get'> = data =>
  instance.get(API.QUESTION_TYPES, { params: data })

export const questionTypesCounts: ApiFunc<`${typeof API.QUESTION_TYPES_COUNTS}`, 'get'> = data =>
  instance.get(API.QUESTION_TYPES_COUNTS, { params: data })

export const questionImport: ApiFunc<`${typeof API.QUESTION_IMPORT}`, 'post'> = data =>
  instance.post(API.QUESTION_IMPORT, data, { headers: { 'Content-Type': 'multipart/form-data' } })
